import script from "./TestConfiguratorModalComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestConfiguratorModalComponent.vue?vue&type=script&setup=true&lang=ts"

import "./TestConfiguratorModalComponent.vue?vue&type=style&index=0&id=de67efec&lang=css"

const __exports__ = script;

export default __exports__